import createDataLink, { open_url } from '@/utils/create-data-link';
import config from '@/config/index';
import { CoreApi } from '../api';
import ProductCountry from '@/interfaces/models/ProductCountry';

export class ExportService extends CoreApi {
  constructor() {
    super();
  }

  downloadInddForGroup(id: string, token: string, scope: any) {
    const url = `${config.API_BASE_URL}/v2/export/indd/${id}?token=${token}&product=${scope.product._id}&country=${scope.country}&customer=${scope.customer}`;
    window.open(url, '_blank', 'menubar=no,titlebar=no,toolbar=no,width=600px,height=500px');
  }

  downloadInddZip(ids: string[]) {
    return this.api('storage', 'v2')
      .post(`/zip/indd`, { ids }, { responseType: 'arraybuffer' })
      .then(result => {
        return createDataLink(result, 'Files.zip');
      });
  }

  donwloadExcel(token: string, scope: any) {
    const url = `${config.API_BASE_URL}/v2/export/excel?token=${token}&product=${scope.product}&country=${scope.country}`;
    window.open(url, '_blank', 'menubar=no,titlebar=no,toolbar=no,width=600px,height=500px');
  }

  presentation(id: string, type: 'chapter' | 'flow', token: string, selection: ProductCountry) {
    // v2/export/present/chapter|flow/:id?token=&country=&product=
    // TODO: url
    const url = `${config.API_BASE_URL}/v2/export/present/${type}/${id}?token=${token}&product=${selection.product}&country=${selection.country}&customer=x`;

    return url;
  }

  sitemap(id: string, type: string, name: string, token: string, selection: ProductCountry) {
    return this.api('export', 'v2')
      .get(
        `/sitemap/${type}/${id}?token=${token}&product=${selection.product}&country=${selection.country}`,
        { responseType: 'arraybuffer' }
      )
      .then(result => {
        return createDataLink(result, name);
      });
  }

  asPdf(id: any, type: any, name: string, selection?: any) {
    return this.api('exports', 'v1')
      .post(`/pdf/${type}/${id}`, { selection }, { responseType: 'arraybuffer' })
      .then(result => {
        return createDataLink(result, name);
      });
  }
}
